import React from 'react';
import { NavLink } from 'react-router-dom';
import cn from 'classnames';

import { Typography } from 'components/shared/Typography';

import { idxMap } from 'helpers/styleMapIdx';

import styles from './Link.module.scss';

const TYPES = {
  default: styles.default,
};

const Link = ({
  className,
  children,
  type,
  to,
  startAdornment,
  endAdornment,
  ...restProps
}: {
  className: any;
  children: any;
  type: any;
  to: any;
  startAdornment: any;
  endAdornment: any;
} & Record<string, any>) => {
  if (to) {
    return (
      <NavLink
        {...restProps}
        to={to}
        className={cn(
          styles.link,
          idxMap(TYPES as Record<string, string>, type),
          className,
        )}
      >
        {startAdornment}
        {children}
        {endAdornment}
      </NavLink>
    );
  }

  return (
    <Typography
      {...restProps}
      className={cn(
        styles.link,
        idxMap(TYPES as Record<string, string>, type),
        className,
      )}
      component="a"
    >
      {startAdornment}
      {children}
      {endAdornment}
    </Typography>
  );
};

Link.defaultProps = {
  type: 'default',
  variant: 'body1',
};

export default React.memo(Link) as any;
